import { spacing, SpacingProps } from '@material-ui/system'
import { rem } from 'polished'
import styled from 'styled-components'

import { IPaginationProps } from '../Pagination'

export const PaginationStyled = styled.div`
  display: inline-block;
  padding: ${(props) => props.theme.typography.pxToRem(0)};
  font-family: inherit;
  font-size: ${(props) => props.theme.typography.pxToRem(12)};
  ${spacing}

  > * {
    vertical-align: middle;
  }
`
